module.exports = __webpack_public_path__ + "static/img/40019 (1).6d0d51f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40019 (1).webp
// module id = ywUe
// module chunks = 14